/**
 * PATH: packages/ui/src/kanban/components/settings-home/RelatedSettingsLinks.tsx
 * FILE_ID: UI-KANBAN-SETTINGS-HOST-LINKS-001
 * PURPOSE: Host-config team and email links. No hardcoded dashboard URLs.
 * ROLE IN ARCHITECTURE: Presentational leaf for All-Kanban outbound navigation.
 * MAIN EXPORTS: RelatedSettingsLinks, resolveKanbanHostLinks.
 * NON-RESPONSIBILITIES: Does not rebuild members, labels, or week-start.
 * NOTES FOR FUTURE AI: Members uses teamSettingsHref. There is no labels
 *   Settings tab, so do not catalog a second door to organisation.
 */

import { getSettingsHubConfig } from '@quotech/tenant-shared/settings/settingsHubConfig'

import type { SettingsCapabilities } from './contract'

export interface KanbanHostLinks {
  teamHref: string
  emailHref: string
}

export function resolveKanbanHostLinks(): KanbanHostLinks {
  const config = getSettingsHubConfig()
  return {
    teamHref: config.teamSettingsHref,
    emailHref: config.emailSettingsHref,
  }
}

export function RelatedSettingsLinks({
  capabilities,
}: {
  capabilities?: Pick<SettingsCapabilities, 'hasEmailSettings' | 'hasOrganisationSettings'>
}) {
  const links = resolveKanbanHostLinks()
  const showTeam = (capabilities?.hasOrganisationSettings ?? true) && Boolean(links.teamHref)
  const showEmail = (capabilities?.hasEmailSettings ?? true) && Boolean(links.emailHref)
  return (
    <div data-testid="settings-host-links">
      {showTeam ? (
        <a
          className="block py-2 text-xs text-blue-700 dark:text-blue-400"
          href={links.teamHref}
          data-testid="settings-host-link-members"
        >
          Org members…
        </a>
      ) : null}
      {showEmail ? (
        <a
          className="block py-2 text-xs text-blue-700 dark:text-blue-400"
          href={links.emailHref}
          data-testid="settings-host-link-email"
        >
          Email sync and notifications…
        </a>
      ) : null}
      <p className="py-2 text-[11px] text-neutral-400">
        Working week is AR/AP / time-board data. There is no Kanban week-start setting.
      </p>
    </div>
  )
}
